import React, { useState, useEffect } from 'react'
import { Button, Row, Col, Tooltip, Select, Checkbox, Spin } from 'antd'
import { connect } from 'react-redux'
import './index.scss';
import { AccountStatementFile, getAccountStatementPdfByIbanRef, getAccountStatementExcelByIbanRef, getAccountStatementPdfLCByIbanRef, getAccountStatementExcelLCByIbanRef } from '../../../../../services/account';

import { PdfIco, SpinnerIco, XlsIco } from '../../../../../../modules/CustomIcons';
import moment from 'moment'
import { useTranslation } from 'react-i18next';

const SalaryPrintFooter: React.FC<any> = ({ ccyName, tableData, startDate, endDate }) => {
  const { t } = useTranslation()
  let footerBtnsSecond = [
    {
      icon: <PdfIco />,
      title: t("accountStatement.downloadPDF"),
      type: "pdf",
      loading: false
    },
    {
      icon: <XlsIco />,
      title: t("transfers.downloadExcel"),
      type: "excel",
      loading: false
    },
  ]
  const [exportDetail, setExportDetail] = useState(footerBtnsSecond);
  const [selectedValue, setSelectedValue] = useState("AZ");
  const [lcValue, setLcValue] = useState(false);
  const selectOptions = ['AZ', 'EN', 'RU'];
  const handleChangeSelect = (value: string) => {
    setSelectedValue(value)
  };


  const exportFile = async (typeClick: string) => {
    const formData = {
      startDate: ccyName.startDate,
      endDate: ccyName.endDate,
      ibanRef: ccyName.iban
    }
    if (typeClick === "pdf") {
      const newExportDedatil = [...exportDetail];
      newExportDedatil[0]["loading"] = true;
      setExportDetail(newExportDedatil)
      if (lcValue) {
        const data = await getAccountStatementPdfLCByIbanRef(formData, selectedValue)
        downloadPDF(data?.data.fileDetailsList[0].fileName, data?.data.fileDetailsList[0].fileBase64);
      } else {
        const data = await getAccountStatementPdfByIbanRef(formData, selectedValue)
        downloadPDF(data?.data.fileDetailsList[0].fileName, data?.data.fileDetailsList[0].fileBase64);
      }
    } else if (typeClick === "excel") {
      const newExportDedatil = [...exportDetail];
      newExportDedatil[1]["loading"] = true;
      setExportDetail(newExportDedatil)
      if (lcValue) {
        const data = await getAccountStatementExcelLCByIbanRef(formData, selectedValue)
        downloadExcel(data?.data.fileDetailsList[0].fileName, data?.data.fileDetailsList[0].fileBase64);
      } else {
        const data = await getAccountStatementExcelByIbanRef(formData, selectedValue)
        downloadExcel(data?.data.fileDetailsList[0].fileName, data?.data.fileDetailsList[0].fileBase64);
      }
    }

    const newExportDedatil = [...exportDetail];
    newExportDedatil[0]["loading"] = false;
    newExportDedatil[1]["loading"] = false;
    setExportDetail(newExportDedatil)
  }

  function downloadPDF(fileName: string, fileBase64: string) {
    const linkSource = `data:application/pdf;base64,${fileBase64}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  function downloadExcel(fileName: string, fileBase64: string) {
    const linkSource = `data:application/vnd.ms-excel;base64,${fileBase64}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const handleClickLCManat = () => {
    setLcValue(!lcValue);
  }

  useEffect(() => {
    setLcValue(false);
  }, [ccyName])
  return (
    <>
      <Row style={{ marginBottom: "30px" }}>
        <Col span={12} style={{ display: 'flex' }}>
          <div className="flex">
            <div
              className="transfers-footer_btns flex"
            >
              <ul
                className="flex"
              >
                <li>
                  <div className="pagination-selector" style={{ left: '0px' }}>
                    <Select defaultValue={selectedValue} placeholder="AZ" width={64} onChange={handleChangeSelect} disabled={tableData ? false : true}>
                      {selectOptions.map((item) => {
                        return <option value={item}>{item}</option>
                      })}
                    </Select>
                  </div>
                </li>
                {exportDetail.map((item) => {
                  return (
                    <li>
                      <Tooltip className="footer-tooltip" title={item.title}>

                        {
                          item.loading ? <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div> :
                            <Button className={"accountPage_exportButtons"} ghost icon={item.icon} onClick={() => exportFile(item.type)} disabled={tableData ? false : true} />
                        }
                      </Tooltip>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>

          {/* <Checkbox
            style={{ height: "80px" }}
            disabled={ccyName.ccy_name === "AZN" || !tableData ? true : false}
            checked={lcValue}
            name={'LC'}
            onChange={handleClickLCManat} >
            {t("accountStatement.equivalentAZN")}
          </Checkbox> */}
        </Col>
        {
          moment(ccyName.endDate).isSame(moment(), 'day') ?
            <Col span={12} className='as-footer-notification-col'>
              <div className='as-footer-notification-divison'>
                {t("accountStatement.operationDateNote")}
              </div>
            </Col> : <></>
        }

      </Row>
    </>
  )
}


const mapStateToProps = (state: any) => ({
  ccyName: state.accountsStatement.ccyName
})

export default connect(mapStateToProps, null)(SalaryPrintFooter)
